import { createSlice } from "@reduxjs/toolkit";

interface SubscriptionData {
  edition_type: string;
  duration_months: number;
  price: number;
  description: string;
  plan: string;
  payment_id: number;
  status: string;
  start_date: string;
  end_date: string;
  cancelled_at: string | null;
  cancellation_reason: string | null;
  web_user: number;
  payment_method: string;
  payment_status: string;
}

interface SubscriptionState {
  subscriptions: SubscriptionData[];
  isSubscribed: boolean;
}

const initialState: SubscriptionState = {
  subscriptions: [],
  isSubscribed: false,
};

const SubscriptionSlice = createSlice({
  name: "Subscription",
  initialState,
  reducers: {
    addSubscription: (state, action) => {
      state.subscriptions.push(action.payload);
      state.isSubscribed = true;
    },
    setSubscriptions: (state, action) => {
      state.subscriptions = action.payload;
      state.isSubscribed = action.payload.length > 0;
    },
    clearSubscriptions: (state) => {
      state.subscriptions = [];
      state.isSubscribed = false;
    },
    updateSubscription: (state, action) => {
      const { payment_id, ...updateData } = action.payload;
      const subscriptionIndex = state.subscriptions.findIndex(
        (sub) => sub.payment_id === payment_id
      );
      
      if (subscriptionIndex !== -1) {
        state.subscriptions[subscriptionIndex] = {
          ...state.subscriptions[subscriptionIndex],
          ...updateData
        };
      } else if (action.payload) {
        // If subscription doesn't exist and we have data, add it as new
        state.subscriptions.push(action.payload);
        state.isSubscribed = true;
      }
    },
    cancelSubscription: (state, action) => {
      const { payment_id, cancelled_at, cancellation_reason } = action.payload;
      const subscription = state.subscriptions.find(
        (sub) => sub.payment_id === payment_id
      );
      
      if (subscription) {
        subscription.status = 'cancelled';
        subscription.cancelled_at = cancelled_at;
        subscription.cancellation_reason = cancellation_reason;
      }
      
      // Update isSubscribed based on whether any active subscriptions remain
      state.isSubscribed = state.subscriptions.some(
        (sub) => sub.status !== 'cancelled'
      );
    },
    removeSubscription: (state, action) => {
      state.subscriptions = state.subscriptions.filter(
        (sub) => sub.payment_id !== action.payload
      );
      state.isSubscribed = state.subscriptions.length > 0;
    }
  }
});

export const {
  addSubscription,
  setSubscriptions,
  clearSubscriptions,
  updateSubscription,
  cancelSubscription,
  removeSubscription
} = SubscriptionSlice.actions;

export default SubscriptionSlice.reducer;